














































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapGetters } from 'vuex'
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin'
import SlideList from '@/components/modules/App/SlideList.vue'
import FlatCard from '@/components/modules/App/Profile/FlatCard.vue'
import NoFlatPlug from '@/components/modules/App/Profile/NoFlatPlug.vue'
import { AppealBooking, CatalogItem } from '@/requests/mainApi'
import { storeModuleName } from '@/views/App/Profile/store'
import { IFlatItem, IBookingItem } from '@/views/App/Profile/store/interfaces'

interface Data {
  viewCurrentFlats: CatalogItem[]
  countInChunk: number
}

interface Methods {
  onSelectChunk: (value: CatalogItem[]) => void
}

interface Computed {
  processedBookingFlats: IFlatItem[]
  bookingFlats: IBookingItem[]
  favouriteFlats: CatalogItem[]
}

interface Props {}

export default Vue.extend({
  name: 'BookingTab',
  components: {
    SlideList,
    FlatCard,
    NoFlatPlug
  },
  mixins: [iconsMixin],
  data () {
    return {
      viewCurrentFlats: [],
      countInChunk: 4
    }
  },
  computed: {
    processedBookingFlats () {
      let relevantFavouriteFlat
      return this.bookingFlats.map(bookingFlat => {
        relevantFavouriteFlat = this.favouriteFlats
          .find(favouriteFlat => favouriteFlat.id === bookingFlat.estate)
        return {
          ...bookingFlat,
          isBooked: true,
          isFavourite: Boolean(relevantFavouriteFlat)
        }
      })
    },
    ...mapGetters(storeModuleName, ['bookingFlats']),
    ...mapGetters(['favouriteFlats'])
  },
  methods: {
    onSelectChunk (value: CatalogItem[]) {
      this.viewCurrentFlats = value
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
